import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
const TeachersCommunitySection = ({ setActiveSection }) => {
  useEffect(() => {
    setActiveSection("teacher community");
  }, [setActiveSection]);
  return (
    <section className="community-sections">
      {/* Teacher Section */}
      <div className="community-section teacher-section">
        <FontAwesomeIcon icon={faChalkboardTeacher} className="section-icon" />
        <h1>For Teachers</h1>
        <p>
          Seed to Tree Online Academy is a prestigious online educational
          platform that offers a wide range of courses and programs designed to
          empower individuals with knowledge and skills. When you join as a
          teacher, you can expect a multitude of benefits and perks, including:
        </p>
        <ul>
          <li>Experience letter/ E-Certification</li>
          <li>Contract based salary</li>
          <li>Virtual teaching environment</li>
          <li>No fuss of managing students</li>
          <li>Marketing will be done by Seed to Tree</li>
        </ul>
        <h3>IMPORTANT NOTE:</h3>
        <ol>
          <li>Fill in the recruitment form</li>
          <li>Our team will review your request form</li>
          <li>
            Hiring will be based on:
            <ul>
              <li>Your CV/ experience</li>
              <li>Course you want to teach</li>
              <li>Your target audience</li>
            </ul>
          </li>
          <li>You will have to create a course outline</li>
        </ol>
        {/* <iframe
          src="https://forms.gle/6YYvW5mTgQX8EuRv5"
          title="Teacher Application Form"
          width="100%"
          height="500px"
          frameBorder="0"
          allow="fullscreen"
        ></iframe> */}
      </div>

      {/* Member Section */}
      <Link to="https://forms.gle/6YYvW5mTgQX8EuRv5" className="community-btn">
        Fill in the Teachers Form
      </Link>
    </section>
  );
};

export default TeachersCommunitySection;
